import types from '../actions/types'

const {
  UPDATE_PLAN_DATA,
  FETCH_PAYMENT_TYPE,
  FETCH_DUE_DATES,
  GET_EDIT_AUTH_PAYMENT,
  SET_EDIT_AUTH_PAYMENT,
  LOCK_EDIT_AUTH_PAYMENT
} = types

function planDataReducer(state = { authorizations: {} }, action = {}) {
  switch (action.type) {
    case UPDATE_PLAN_DATA: {
      return {
        ...state,
        ...action.plandata
      }
    }
    case FETCH_PAYMENT_TYPE: {
      return {
        ...state,
        paymentTypes: action.paymentTypes
      }
    }
    case FETCH_DUE_DATES: {
      return {
        ...state,
        dueDates: action.dueDates
      }
    }
    case GET_EDIT_AUTH_PAYMENT:
    case LOCK_EDIT_AUTH_PAYMENT: {
      return {
        ...state,
        authorizations: {
          ...state.authorizations,
          [action.changeType]: action.authorizations
        }
      }
    }
    case SET_EDIT_AUTH_PAYMENT: {
      return {
        ...state,
        authorizations: {
          ...state.authorizations,
          [action.changeType]: {
            ...action.authorizations.message
          }
        }
      }
    }
    default:
      return state
  }
}

export default planDataReducer



// WEBPACK FOOTER //
// ./src/alelo-logic/reducers/planDataReducer.js